(function (ws) {
    'use strict';

    ws.views.shipping = ws.views.form.extend({

        events: _.extend({}, ws.views.form.prototype.events, {
            'change #addressBook': 'onSelectAddressBookChanged',
            'change #pickUpAddressBook': 'onSelectPickUpAddressBookChanged',
            'change [name=country]': 'updateStates',
            'change [name=pickUpCountry]': 'updatePickUpStates',
            'blur #zipCode': 'autocompleteByZipCode',
            'blur #pickUpZip': 'autocompleteByZipCodePickUp',
            'keydown input:not("textarea")': 'preventSubmitOnEnter'
        }),

        /**
         * Initialize view
         */
        initialize: function () {
            ws.views.form.prototype.initialize.call(this);

            this.$requiresShipping = $('#requiresShipping');
            this.$requiresPickup = $('#requiresPickup');

            //in some components the contact and shipping components are not separated.
            //In those cases we need to know when to initialize the shipping part of the form
            //if shipping is required.
            if (this.$requiresShipping.length === 0 || this.$requiresShipping.val() || this.$requiresPickup.val()) {
                // Templates
                if (this.$('#statesListOptionsTemplate').html()) {
                    this.statesListOptionsTemplate = _.template(this.$('#statesListOptionsTemplate').html());
                }

                // DOM Elements
                this.$datePickers = this.$('.datepicker');
                this.defaultNewAddressCountry = this.$('#newAddressContainer #country').val();

                this.$addressBookList = this.$('#addressBook');
                this.$newAddressContainer = this.$newAddressContainer || this.$('#newAddressContainer');
                this.$newAddressCountryList = this.$newAddressContainer.find('#country');
                this.$newAddressStateList = this.$newAddressContainer.find('#state');
                this.$newAddressStateLabel = this.$newAddressContainer.find('label[for="state"]');
                this.$newAddressOptionalStateLabel = this.$newAddressContainer.find('label[for="optionalState"]');
                this.$newAddressCity = this.$newAddressContainer.find('#city');
                this.$newAddressZipCode = this.$newAddressContainer.find('#zipCode');
                this.$newAddressZipCodeLabel = this.$newAddressContainer.find('label[for="zipCode"]');
                this.$newAddressOptionalZipCodeLabel = this.$newAddressContainer.find('label[for="optionalZipCode"]');

                this.$pickUpAddressBookList = this.$('#pickUpAddressBook');
                this.$pickUpNewAddressContainer = this.$('#pickUpNewAddressContainer');
                this.$pickUpNewAddressCountryList = this.$pickUpNewAddressContainer.find('#country');
                this.$pickUpNewAddressStateList = this.$pickUpNewAddressContainer.find('#pickUpState');
                this.$pickUpNewAddressStateLabel = this.$pickUpNewAddressContainer.find('label[for="pickUpState"]');
                this.$pickUpNewAddressOptionalStateLabel = this.$pickUpNewAddressContainer.find('label[for="optionalState"]');
                this.$pickUpNewAddressCity = this.$pickUpNewAddressContainer.find('#pickUpState');
                this.$pickUpNewAddressZipCode = this.$pickUpNewAddressContainer.find('#pickUpZip');
                this.$pickUpNewAddressZipCodeLabel = this.$pickUpNewAddressContainer.find('label[for="pickUpZip"]');
                this.$pickUpNewAddressOptionalZipCodeLabel = this.$pickUpNewAddressContainer.find('label[for="optionalZipCode"]');

                this.$endUserAddress = this.$('.end-user-addrs');
                this.$endUserAddressCheckbox = this.$('#sameAsShippingAddress');
                this.$endUserCountryList = this.$endUserAddress.find('#country');
                this.$endUserStateList = this.$endUserAddress.find('#state');
                this.$endUserStateLabel = this.$endUserAddress.find('label[for="state"]');
                this.$endUserOptionalStateLabel = this.$endUserAddress.find('label[for="optionalState"]');
                this.$endUserCity = this.$endUserAddress.find('#city');
                this.$endUserZipCode = this.$endUserAddress.find('#zipCode');
                this.$endUserZipCodeLabel = this.$endUserAddress.find('label[for="zipCode"]');
                this.$endUserOptionalZipCodeLabel = this.$endUserAddress.find('label[for="optionalZipCode"]');

                this.$selectElements = this.$('select');
                this.$saveToAddressBookCheckbox = this.$saveToAddressBookCheckbox || this.$newAddressContainer.find('#saveToAddressBook');

                // Errors
                this.$error = this.$('.error');
                this.$requiredErrorMessage = this.$('.required-error-message');

                this.eventAgg.on('qut-openShippingInfoModalOnClose', this.clearValidation.bind(this));

                // Firefox doesn't recognise delegated events for disabled fieldset elements, so binding them directly
                this.$('.address-type-selector').on('change', this.onAddressEntryTypeChanged.bind(this));
                this.$('.pickup-address-type-selector').on('change', this.onPickUpAddressEntryTypeChanged.bind(this));
                $('.address-saved-shipping-checkbox').on('change', this.onSavedShippingInstructionsChanged.bind(this));

                this.render();
            }
        },

        /**
         * Update address fields with selected country
         * And update labels and make mandatory fields if needed.
         * In the event that an ev object is passed,
         * Make mandatory and update labels depends on the container of the selected element.
         *
         * @param {Object} countries
         * @param {Object} [ev] - Event object provided by the browser
         */
        updateFieldsWithCountry: function(countries, ev) {

            // TODO: needs to be refractor this code
            if (typeof ev !== 'undefined') {

                if ($(ev.target).hasClass('shipping-country')) {

                    const $container = $(ev.currentTarget).parents('.comp-shipping');
                    this.$newAddressCountryList = $container.find('#newAddressContainer #country');
                    this.$newAddressZipCode = $container.find('#newAddressContainer #zipCode');
                    this.$newAddressStateList = $container.find('#newAddressContainer #state');
                    this.$newAddressZipCodeLabel = $container.find('label[for="zipCode"]');
                    this.$newAddressOptionalZipCodeLabel = $container.find('label[for="optionalZipCode"]');
                    this.$newAddressStateLabel = $container.find('label[for="state"]');
                    this.$newAddressOptionalStateLabel = $container.find('label[for="optionalState"]');

                    this.shippingCountryToggle(countries);

                } else if ($(ev.target).hasClass('end-user-country')) {

                    const $container = $(ev.currentTarget).parents('.comp-shipping');
                    this.$endUserCountryList = $container.find('#country');
                    this.$endUserZipCode = $container.find('#zipCode');
                    this.$endUserStateList = $container.find('#state');
                    this.$endUserZipCodeLabel = $container.find('label[for="zipCode"]');
                    this.$endUserOptionalZipCodeLabel = $container.find('label[for="optionalZipCode"]');
                    this.$endUserStateLabel = $container.find('label[for="state"]');
                    this.$endUserOptionalStateLabel = $container.find('label[for="optionalState"]');
                    this.$endUserCity = $container.find('#city');

                    this.enduserCountryToggle(countries);

                }
            } else {
                this.shippingCountryToggle(countries);
                this.enduserCountryToggle(countries);
                this.pickUpCountryToggle(countries);
            }
        },

        /**
         * Shipping address optional field toggling
         */
        shippingCountryToggle: function (countries) {
            const shippingCountry = countries.getCountry(this.$newAddressCountryList.val());

            if (shippingCountry) {
                if ($('#enableMDMTrilliumAddressValidation').val() !== 'true') {
                    this.$newAddressZipCode.toggleClass('mandatory', shippingCountry.postalCodeRequired);
                    this.$newAddressStateList.toggleClass('mandatory', shippingCountry.regionRequired);
                }

                this.$newAddressZipCode.attr('placeholder', shippingCountry.postalCodeSample);
                this.$newAddressZipCodeLabel.toggle(shippingCountry.postalCodeRequired);
                this.$newAddressOptionalZipCodeLabel.toggle(!shippingCountry.postalCodeRequired);
                this.$newAddressStateLabel.toggle(shippingCountry.regionRequired);
                this.$newAddressOptionalStateLabel.toggle(!shippingCountry.regionRequired);

                // Mock event object
                this.updateStates({
                    currentTarget: this.$newAddressCountryList
                });
            }
        },

        /**
         * Shipping address optional field toggling
         */
        pickUpCountryToggle: function (countries) {
            const pickUpCountry = countries.getCountry(this.$pickUpNewAddressCountryList.val());

            if (pickUpCountry) {
                if ($('#enableMDMTrilliumAddressValidation').val() !== 'true') {
                    this.$pickUpNewAddressZipCode.toggleClass('mandatory', pickUpCountry.postalCodeRequired);
                    this.$pickUpNewAddressStateList.toggleClass('mandatory', pickUpCountry.regionRequired);
                }

                this.$pickUpNewAddressZipCode.attr('placeholder', pickUpCountry.postalCodeSample);
                this.$pickUpNewAddressZipCodeLabel.toggle(pickUpCountry.postalCodeRequired);
                this.$pickUpNewAddressOptionalZipCodeLabel.toggle(!pickUpCountry.postalCodeRequired);
                this.$pickUpNewAddressStateLabel.toggle(pickUpCountry.regionRequired);
                this.$pickUpNewAddressOptionalStateLabel.toggle(!pickUpCountry.regionRequired);

                // Mock event object
                this.updatePickUpStates({
                    currentTarget: this.$pickUpNewAddressCountryList
                });
            }
        },

        /**
         * End User address optional field toggling
         */
        enduserCountryToggle: function (countries) {
            const endUserCountry = countries.getCountry(this.$endUserCountryList.val());

            if (endUserCountry) {
                if ($('#enableMDMTrilliumAddressValidation').val() !== 'true') {
                    this.$endUserZipCode.toggleClass('mandatory', endUserCountry.postalCodeRequired);
                    this.$endUserStateList.toggleClass('mandatory', endUserCountry.regionRequired);
                }

                this.$endUserZipCode.attr('placeholder', endUserCountry.postalCodeSample);
                this.$endUserZipCodeLabel.toggle(endUserCountry.postalCodeRequired);
                this.$endUserOptionalZipCodeLabel.toggle(!endUserCountry.postalCodeRequired);
                this.$endUserStateLabel.toggle(endUserCountry.regionRequired);
                this.$endUserOptionalStateLabel.toggle(!endUserCountry.regionRequired);

                // Mock event object
                this.updateStates({
                    currentTarget: this.$endUserCountryList
                });
            }
        },

        /**
         * Modify rendered DOM elements
         */
        render: function () {
            // Check for every shipping component in the page.
            _.each(this.$('.comp-shipping'), function (container) {
                var $container = $(container);
                var $addressBookSelector = $container.find('#selectFromAddress');
                var $addressBookList = $container.find('#addressBook');

                this.disableAdressOptions({
                    currentTarget: $container.find('.address-type-selector:checked')[0]
                });

                if ($addressBookSelector.is(':checked')) {
                    // Mock event object.
                    this.onSelectAddressBookChanged({
                        currentTarget: $addressBookList[0]
                    });
                }
            }.bind(this));

            _.each(this.$('.comp-pickUp'), function (container) {
                var $container = $(container);
                var $addressBookSelector = $container.find('#selectFromPickUpAddress');
                var $addressBookList = $container.find('#pickUpAddressBook');

                this.disablePickUpAddressOptions({
                    currentTarget: $container.find('.pickup-address-type-selector:checked')[0]
                });

                if ($addressBookSelector.is(':checked')) {
                    // Mock event object.
                    this.onSelectPickUpAddressBookChanged({
                        currentTarget: $addressBookList[0]
                    });
                }
            }.bind(this));

            this.$datePickers.pikaday({
                format: dateFormat
            });

            /*
            this.$selectElements.select2({
                width: '100%',
                minimumResultsForSearch: -1
            });
            */
        },

        /**
         * Disable Adress fieldsets that is not checked
         * @param {Object} ev - Event object provided by the browser
         */
        disableAdressOptions: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-shipping');
            var $enabledAddressFieldset = $(ev.currentTarget).parents('.address-type-fieldset');
            this.$addressTypeFieldsets = $container.find('.address-type-fieldset');

            // this.$addressTypeFieldsets.prop('disabled', false);
            // this.$addressTypeFieldsets.find('select').prop('disabled', false);

            this.$addressTypeFieldsets.prop('disabled', true);
            this.$addressTypeFieldsets.find('select').prop('disabled', true);
            $enabledAddressFieldset.prop('disabled', false);
            $enabledAddressFieldset.find('select').prop('disabled', false);
        },

        /**
         * Disable Adress fieldsets that is not checked
         * @param {Object} ev - Event object provided by the browser
         */
        disablePickUpAddressOptions: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-pickUp');
            var $enabledAddressFieldset = $(ev.currentTarget).parents('.pickup-address-type-fieldset');
            this.$addressTypeFieldsets = $container.find('.pickup-address-type-fieldset');

            // this.$addressTypeFieldsets.prop('disabled', false);
            // this.$addressTypeFieldsets.find('select').prop('disabled', false);

            this.$addressTypeFieldsets.prop('disabled', true);
            this.$addressTypeFieldsets.find('select').prop('disabled', true);
            $enabledAddressFieldset.prop('disabled', false);
            $enabledAddressFieldset.find('select').prop('disabled', false);
        },

        /**
         * Avoid submitting the form when the user hit the Enter key.
         * @param {Object} ev - Event object provided by the browser
         */
        preventSubmitOnEnter: function (ev) {
            if (ev.which === 13) {
                ev.preventDefault();
                ev.stopPropagation();
                return false;
            }
        },

        /**
         * Additional field validations
         */
        additionalValidation: function () {
            this.checkDate();
            this.checkAddressBookSelection();
            this.checkPickUpAddressBookSelection();
        },

        /**
         * Is North America?
         */
        isNorthAmerica: function () {
            return ['US', 'CA'].indexOf(this.$('#newAddressContainer #country').val()) > -1;
        },

        /**
         * Is North America?
         */
        isPickUpNorthAmerica: function () {
            return ['US', 'CA'].indexOf(this.$('#pickUpNewAddressContainer #country').val()) > -1;
        },

        /**
         * Additional validation for Address Book option
         */
        checkAddressBookSelection: function () {
            // Check for every shipping component in the page.
            _.each(this.$('.comp-shipping'), function (container) {
                var $container = $(container);
                var $addressBookSelector = $container.find('#selectFromAddress');
                var $addressBookList = $container.find('#addressBook');
                var $addressBookRequiredError = $container.find('#addressBookContainer .required-error-message');

                if ($addressBookSelector.is(':checked') && !$addressBookList.val()) {
                    $addressBookRequiredError.show();
                    this.error = true;
                }
            }.bind(this));
        },

        /**
         * Additional validation for Address Book option
         */
        checkPickUpAddressBookSelection: function () {
            // Check for every shipping component in the page.
            _.each(this.$('.comp-pickUp'), function (container) {
                var $container = $(container);
                var $addressBookSelector = $container.find('#selectFromPickUpAddress');
                var $addressBookList = $container.find('#pickUpAddressBook');
                var $addressBookRequiredError = $container.find('#addressBookContainer .required-error-message');

                if ($addressBookSelector.is(':checked') && !$addressBookList.val()) {
                    $addressBookRequiredError.show();
                    this.error = true;
                }
            }.bind(this));
        },

        /**
         * Populate address fields if user selects address from address book
         * @param {Object} ev - Event object provided by the browser
         */
        onSelectAddressBookChanged: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-shipping');
            var $addressBookList = $container.find('#addressBook');
            var $newAddressCountryList = $container.find('#newAddressContainer #country');

            // this.$addressTypeFieldsets = $container.find('.address-type-fieldset');

            if ($addressBookList.val()) {
                // this.$addressTypeFieldsets.prop('disabled', true);
                // this.$addressTypeFieldsets.find('select').prop('disabled', true);

                var addressData = $addressBookList.find('option:selected').data('attr');
                var country = _.findWhere(addressData, {name: 'country'});

                // When Address Book has a value, show pre-filed fields to show details address.
                this.$newAddressContainer.show();

                // If country is not the currently selected country,
                // then it needs to fetch and update the list of states.
                if (country.value !== $newAddressCountryList.val()) {
                    this.fetchStates = $.Deferred();
                    $newAddressCountryList.val(country.value).trigger('change');
                    this.fetchStates.done(function () {
                        this.updateInputsWithAddressBookData(addressData, $container);
                    }.bind(this));
                } else {
                    this.updateInputsWithAddressBookData(addressData, $container);
                }
            }
        },

        onSelectPickUpAddressBookChanged: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-pickUp');
            var $addressBookList = $container.find('#pickUpAddressBook');
            var $newAddressCountryList = $container.find('#newAddressContainer #country');

            // this.$addressTypeFieldsets = $container.find('.address-type-fieldset');

            if ($addressBookList.val()) {
                // this.$addressTypeFieldsets.prop('disabled', true);
                // this.$addressTypeFieldsets.find('select').prop('disabled', true);

                var addressData = $addressBookList.find('option:selected').data('attr');
                var country = _.findWhere(addressData, {name: 'country'});

                // When Address Book has a value, show pre-filed fields to show details address.
                this.$newAddressContainer.show();

                // If country is not the currently selected country,
                // then it needs to fetch and update the list of states.
                if (country.value !== $newAddressCountryList.val()) {
                    this.fetchStates = $.Deferred();
                    $newAddressCountryList.val(country.value).trigger('change');
                    this.fetchStates.done(function () {
                        this.updateInputsWithPickUpAddressBookData(addressData, $container);
                    }.bind(this));
                } else {
                    this.updateInputsWithPickUpAddressBookData(addressData, $container);
                }
            }
        },

        /**
         * Set Address Book data into form inputs
         * @param {Object} addressData
         */
        updateInputsWithAddressBookData: function (addressData, $container, type) {
            var inputValue = $container.find('#addressBook').val();
            var $newAddressContainer = $container.find('#newAddressContainer');
            var $saveToAddressBookCheckbox = $newAddressContainer.find('#saveToAddressBook');
            var isTrilliumVerified = false;
            let country = '';

            _.each(addressData, function (data) {
                var $input = $newAddressContainer.find('#' + data.name);

                $input.val(inputValue ? data.value : '');
                if (data.name === 'state' && data.value !== '') {
                    $('#getStateSelected').val(data.value);
                }

                if (data.name === 'country' && data.value !== '') {
                    country = data.value;
                }

                // Trigger the change event so select2 knows about the change.
                if ($input.is('select')) {
                    $input.trigger('change.select2');
                }

                //toggle depending upon triliumVerified flag
                if (data.name === 'isTrilliumVerified') {
                    isTrilliumVerified = data.value === 'true' ? true : false;
                }
            }.bind(this));

            $saveToAddressBookCheckbox.attr('checked', false);

            if ($('#enableMDMTrilliumAddressValidation').val() === 'true') {
                $('.new-address-fieldset').prop('disabled', isTrilliumVerified);
                $('.new-address-fieldset').find('select').prop('disabled', isTrilliumVerified);

                if (!isTrilliumVerified) {
                    $('.new-address-fieldset #saveToAddressBook').prop('disabled', true);
                }

                if (!isTrilliumVerified && (isOrderEntrySite || isQuotingSite)) {
                    this.eventAgg.trigger('mdmDynamicSearchShipTo', 'newAddressContainer');
                } else if (!isTrilliumVerified && $('.shipping-section #addressBook').val() && type === 'shipping') {
                    this.eventAgg.trigger('shipToAccountLookupModal');
                    this.eventAgg.trigger('mdmDynamicSearchShipTo', 'newAddressContainerPopUp');
                    setTimeout(function() {
                        $('.comp-ship-to-account-lookup #country').val(country).trigger('change');
                    }, 400);
                } else if (!isTrilliumVerified && $('.endUser-section #addressBook').val() && type === 'endCustomer' && !$('#sameAsShippingAddress').is(':checked')) {
                    this.eventAgg.trigger('endUserAccountLookupModal');
                    this.eventAgg.trigger('mdmDynamicSearchEndCustomer', 'newAddressContainerPopUp');
                    setTimeout(function() {
                        $('.comp-end-user-account-lookup #country').val(country).trigger('change');
                    }, 400);
                }
            }
        },

        updateInputsWithPickUpAddressBookData: function (addressData, $container) {
            var inputValue = $container.find('#pickUpAddressBook').val();
            var $newAddressContainer = $container.find('#pickUpNewAddressContainer');
            var $saveToAddressBookCheckbox = $newAddressContainer.find('#pickUpSaveToAddressBook');

            _.each(addressData, function (data) {
                var $input = $newAddressContainer.find('#' + data.name);
                $input.val(inputValue ? data.value : '');

                // Trigger the change event so select2 knows about the change.
                if ($input.is('select')) {
                    $input.trigger('change.select2');
                }
            }.bind(this));

            $saveToAddressBookCheckbox.attr('checked', false);
        },

        /**
         * Handle changed address entry fieldset trigger
         * @param {Object} ev - Event object provided by the browser
         */
        onAddressEntryTypeChanged: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-shipping');
            var $enabledAddressFieldset = $(ev.currentTarget).parents('.address-type-fieldset');
            this.$addressTypeFieldsets = $container.find('.address-type-fieldset');

            $container.find('.required-error-message').hide();
            $container.find('#addressBook').removeClass('error');

            this.$addressTypeFieldsets.prop('disabled', true);
            this.$addressTypeFieldsets.find('select').prop('disabled', true);

            $enabledAddressFieldset.prop('disabled', false);
            $enabledAddressFieldset.find('select').prop('disabled', false);
            $container.find('.error').removeClass('error');

            this.cleanAllInputsAddress();

            $container.find('#addressBook').trigger('change');
            $container.find('.select-style.ckt-country').val(this.defaultNewAddressCountry).trigger('change');

            if (ev.currentTarget.id === 'newAddress' && $('#enableMDMTrilliumAddressValidation').val() === 'true') {
                $('#newAddressContainer .hiddenTrilliumFields').addClass('hide');
            }
        },

        /**
         * Handle changed address entry fieldset trigger
         * @param {Object} ev - Event object provided by the browser
         */
        onPickUpAddressEntryTypeChanged: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-pickUp');
            var $enabledAddressFieldset = $(ev.currentTarget).parents('.pickup-address-type-fieldset');
            this.$addressTypeFieldsets = $container.find('.pickup-address-type-fieldset');

            $container.find('.required-error-message').hide();
            $container.find('#pickUpAddressBook').removeClass('error');

            this.$addressTypeFieldsets.prop('disabled', true);
            this.$addressTypeFieldsets.find('select').prop('disabled', true);

            $enabledAddressFieldset.prop('disabled', false);
            $enabledAddressFieldset.find('select').prop('disabled', false);
            $container.find('.error').removeClass('error');

            this.cleanAllInputsAddress();

            $container.find('#pickUpAddressBook').trigger('change');
            $container.find('.select-style.ckt-country').val(this.defaultNewAddressCountry).trigger('change');
        },

        /**
         * Clear all inputs if user is entering a new address.
         */
        cleanAllInputsAddress: function () {
            _.each(this.$addressTypeFieldsets.find('input[type="text"], select:not("#countryCode")'), function (input) {
                $(input).val('');

                // Trigger the change event so select2 knows about the change.
                if ($(input).is('select')) {
                    $(input).trigger('change.select2');
                }
            });

            this.$addressTypeFieldsets.find('.createAddressLink').addClass('hide');
        },

        /**
         * Handle changed saved shipping instructions checkbox
         * @param {Object} ev - Event object provided by the browser
         */
        onSavedShippingInstructionsChanged: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-shipping');
            var isChecked = $(ev.currentTarget).prop('checked');

            $container.find('.address-saved-shipping-select').prop('disabled', !isChecked);
            $container.find('.shipping-intruction-textarea').prop('disabled', isChecked);
            $container.find('.save-shipping-instructions-checkbox').prop('disabled', isChecked);
        },

        /**
         * Look for an address based on zip code entry and fill in country, site and state if address if found
         * @param {Object} ev - Event object provided by the browser
         */
        autocompleteByZipCode: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-shipping');
            var $newAddressZipCode = $container.find('#newAddressContainer #zipCode');
            var $newAddressCountryList = $container.find('#newAddressContainer #country');
            var $newAddressCity = $container.find('#newAddressContainer #city');
            var $newAddressStateList = $container.find('#newAddressContainer #state');

            // Prevent if is not North America
            if (this.isNorthAmerica() && $newAddressZipCode.val() !== '') {
                var model = new ws.models.shippingZipcode({
                    zip: $newAddressZipCode.val()
                });

                model.fetch().done(function (response) {
                    if (response.town) {
                        $newAddressCity.val(response.town).removeClass('error');
                        $newAddressCity.siblings('span').hide();
                    }

                    if (response.country && response.country.isocode) {
                        $newAddressCountryList.val(response.country.isocode).trigger('change.select2');

                        // Manually reset error state to prevent change event trigger that retrieves the regions again
                        $newAddressCountryList.removeClass('error').next('.required-error-message').hide();
                    }

                    if (response.region && response.region.isocode) {
                        this.updateStatesWithData(new ws.collections.shippingStates(response.stateList), $container);
                        $newAddressStateList.val(response.region.isocode).trigger('change.select2');
                    }
                }.bind(this));
            }
        },

        /**
         * Look for an address based on zip code entry and fill in country, site and state if address if found
         * @param {Object} ev - Event object provided by the browser
         */
        autocompleteByZipCodePickUp: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-pickUp');
            var $newAddressZipCode = $container.find('#pickUpNewAddressContainer #pickUpZip');
            var $newAddressCountryList = $container.find('#pickUpNewAddressContainer #country');
            var $newAddressCity = $container.find('#pickUpNewAddressContainer #pickUpCity');
            var $newAddressStateList = $container.find('#pickUpNewAddressContainer #pickUpState');

            // Prevent if is not North America
            if (this.isPickUpNorthAmerica() && $newAddressZipCode.val() !== '') {
                var model = new ws.models.shippingZipcode({
                    zip: $newAddressZipCode.val()
                });

                model.fetch().done(function (response) {
                    if (response.town) {
                        $newAddressCity.val(response.town).removeClass('error');
                        $newAddressCity.siblings('span').hide();
                    }

                    if (response.country && response.country.isocode) {
                        $newAddressCountryList.val(response.country.isocode).trigger('change.select2');

                        // Manually reset error state to prevent change event trigger that retrieves the regions again
                        $newAddressCountryList.removeClass('error').next('.required-error-message').hide();
                    }

                    if (response.region && response.region.isocode) {
                        this.updatePickUpStatesWithData(new ws.collections.shippingStates(response.stateList), $container);
                        $newAddressStateList.val(response.region.isocode).trigger('change.select2');
                    }
                }.bind(this));
            }
        },

        /**
         * Update state list based on selected country
         * @param {Object} ev - Event object provided by the browser
         * @param {Function} callback - Function callback to execute once the state list was updated.
         */
        updateStates: function (ev, callback) {
            var $container = $(ev.currentTarget).parents('.comp-shipping');
            var $newAddressCountryList = $container.find('#newAddressContainer #country');

            if ($newAddressCountryList.val() !== '') {
                var regions = new ws.collections.shippingStates([], {
                    iso: $newAddressCountryList.val()
                });

                regions.fetch().done(function () {
                    this.updateStatesWithData(regions, $container);

                    if (typeof callback === 'function') {
                        callback();
                    }

                    // this.onSelectAddressBookChanged({
                    //     currentTarget: $container.find('#addressBook')[0]
                    // });
                }.bind(this));
            }
        },

        updatePickUpStates: function (ev, callback) {
            var $container = $(ev.currentTarget).parents('.comp-pickUp');
            var $newAddressCountryList = $container.find('#country');

            if ($newAddressCountryList.val() !== '') {
                var regions = new ws.collections.shippingStates([], {
                    iso: $newAddressCountryList.val()
                });

                regions.fetch().done(function () {
                    this.updatePickUpStatesWithData(regions, $container);

                    if (typeof callback === 'function') {
                        callback();
                    }

                    // this.onSelectAddressBookChanged({
                    //     currentTarget: $container.find('#addressBook')[0]
                    // });
                }.bind(this));
            }
        },

        /**
         * Update state list base on data passed
         * @param {Object} statesCollection - This should be a `ws.collections.states` collection
         */
        updateStatesWithData: function (statesCollection, $container) {
            $container.find('#newAddressContainer #state').html(this.statesListOptionsTemplate({
                states: statesCollection.toJSON()
            }));
            $container.find('#newAddressContainer #state').val($('#getStateSelected').val());
            if (this.fetchStates) {
                this.fetchStates.resolve();
            }
        },

        /**
         * Update state list base on data passed
         * @param {Object} statesCollection - This should be a `ws.collections.states` collection
         */
        updatePickUpStatesWithData: function (statesCollection, $container) {
            $container.find('#pickUpNewAddressContainer #pickUpState').html(this.statesListOptionsTemplate({
                states: statesCollection.toJSON()
            }));

            if (this.fetchStates) {
                this.fetchStates.resolve();
            }
        }

    });
})(westcon);
